import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Pagination, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Page from '../../component/Page'
import api from '../../api/api'
import { useSelector } from 'react-redux'

export default function DistributionPlan() {
    const [data, setData] = useState([])
    const { profile } = useSelector(state => state.profile)

    const [documentNo, setDocumentNo] = useState('')
    // const [page, setPage] = React.useState(1);
    const [searchParams, setSearchParams] = useSearchParams()
    let q = searchParams.get('q') || ''
    let id = searchParams.get('id') || ''
    let page = searchParams.get('page') || '1'
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const getData = async () => {
        setLoading(true)
        const res = await api.get(`plan/sales?documentNo=${q}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setData(data)
            setLoading(false)
        }
    }
    useEffect(() => {
        getData()
    }, [q])
    return (
        <Page>

            <div class="container-fluid">

                <div class=" d-flex row justify-content-between align-items-baseline">
                    <div class="col-lg-4 col-md-12 text-left ">
                        <label class="title-content mb-4">
                            รายการแผนการจำหน่าย
                        </label>
                    </div>
                    {profile?.BranchNo?.BranchNo !== '00' &&

                        <div class="col-lg-4 col-md-12 text-end px-4">
                            <Link to={`/plan/distribution-plan/add`}>
                                <Button type="button" className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
                            </Link>

                        </div>}
                    <div class="col-lg-4 col-md-12">
                        <Box className='backgroundField'>
                            <TextField value={q} onChange={e => setSearchParams({ q: e.target.value })} variant="standard" fullWidth placeholder="ค้นหา เลขที่เอกสาร"
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: <Box sx={{ marginRight: '10px' }}><FontAwesomeIcon icon={faSearch} /></Box>,
                                }}
                            />
                        </Box>

                    </div>
                </div>

                <div class="listData row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div class="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                        <th class="text-center">เลขที่เอกสาร</th>
                                        <th class="text-center">ประจำปีงบประมาณ</th>
                                        <th class="text-center">สถานะ</th>
                                        <th class="text-center">ดำเนินการ</th>
                                    </tr>
                                </thead>
                                <tbody class="cp">
                                    {
                                        data?.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)?.map((x, i) => (
                                            <tr className={id === x?.DocumentNo ? 'active' : ''}>
                                                <td class="text-center">{x?.BranchNo?.BranchName}</td>
                                                <td class="text-center">{x?.DocumentNo}</td>
                                                <td class="text-center">{x?.Year} {x?.Version ? `ครั้งที่ ${x?.Version}` : ''}</td>
                                                <td class="text-center">
                                                    <span class="status-active">
                                                        ใช้งาน
                                                    </span>

                                                </td>
                                                <td class="text-center">
                                                    <Link to={`/plan/distribution-plan/${x?.DocumentNo}`} onClick={() => setSearchParams({ id: x?.DocumentNo, page: page, q: q, })}>
                                                        <Button variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>เรียกดู</Button>
                                                    </Link>

                                                </td>
                                            </tr>
                                        ))
                                    }




                                </tbody>
                            </table>
                        </div>}
                    <div class="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={Math.ceil(data.length / rowsPerPage)} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, id: id })} shape="rounded" />

                    </div>
                </div>
            </div>
        </Page >
    )
}
